<template>
  <div :class="$style.wrapper">
    <div :class="$style.container">
      <div :class="$style.logoWrap" @click="$router.push('/')">
        <img :class="$style.logo" src="@/assets/images/linkooklive_longlogo.png" alt="링꾹라이브" />
      </div>
      <div :class="$style.content">
        <p :class="$style.code">404</p>
        <p :class="$style.message">페이지를 찾을 수 없습니다.</p>
        <p :class="$style.sub">요청하신 주소의 페이지가 없거나 이동되었을 수 있습니다.</p>
      </div>
      <button :class="$style.homeButton" @click="$router.push('/')">홈으로 가기</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style module>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  background: #fff;
  font-family: "NanumSquareRoundR", sans-serif;
}

.container {
  text-align: center;
  padding: 40px 24px;
  max-width: 480px;
  width: 100%;
}

.logoWrap {
  cursor: pointer;
  margin-bottom: 32px;
  display: inline-block;
}

.logoWrap:hover {
  opacity: 0.85;
}

.logo {
  width: 220px;
  height: auto;
  display: block;
}

.content {
  margin-bottom: 32px;
}

.code {
  margin: 0 0 12px 0;
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  font-family: "NanumSquareRoundEB", sans-serif;
  letter-spacing: -0.02em;
}

.message {
  margin: 0 0 8px 0;
  font-size: 1.1rem;
  color: #333;
  font-family: "NanumSquareRoundB", sans-serif;
}

.sub {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
}

.homeButton {
  background: #fff;
  color: #333;
  border: 1px solid #ddd;
  cursor: pointer;
  padding: 12px 28px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: bold;
  font-family: "NanumSquareRoundEB", sans-serif;
  transition: all 0.2s ease;
}

.homeButton:hover {
  background: #f8f9fa;
  border-color: #ccc;
  transform: scale(1.02);
}

@media (max-width: 480px) {
  .container {
    padding: 32px 20px;
  }

  .logo {
    width: 180px;
  }

  .code {
    font-size: 2rem;
  }

  .message {
    font-size: 1rem;
  }

  .sub {
    font-size: 0.85rem;
  }
}
</style>
